import { QueryClient } from '@tanstack/react-query'

// Note: exported as a module singleton so non-React code (the offline mutation layer) can patch the
// cache directly. Components should still reach it through useQueryClient.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60 * 24,
      networkMode: 'offlineFirst',
    },
  },
})
